<template>
    <!-- 订单管理 -->
    <div class="order">
        <div class="order_head">
            <ul>
                <li v-for="(item,index) in tabsCard.tabs" :class="index == tabsCard.num ? 'active' : ''" :key="index" @click="tab(index)">
                    <span>{{ item }}</span>
                </li>
            </ul>
            <span v-if="!isEdit" @click="changeEditStatus">编辑</span>
            <div v-else class="barSty">
                <span style="margin-right: 10px;" @click="cancelEdit(false)">取消</span>
                <span @click="cancelEdit(true)">删除</span>
            </div>
        </div>
        <div class="main">
            <!-- 今天 -->
            <div v-if="tabsCard.num == 0" >
                <el-checkbox-group v-model="checkList">
                    <div class="orderItem" v-for="(item,index) in showData" :key='index'>
                        <div class="titleImg">
                            <div class="order-img" @click="jumpToVideo(item.videoInfo.status, item.videoInfo.id)">
                                <img v-if="item.videoInfo" :src="item.videoInfo.horizontalImage" alt="">
                                <img v-else src="@/assets/images/mine/vip_recharge.png" alt=""> 
                            </div>
                            <!-- <img v-if="item.videoInfo" :src="item.videoInfo.horizontalImage" alt="">
                            <img v-else src="@/assets/images/mine/vip_recharge.png" alt=""> -->
                            <div class="layer" v-show="isEdit">
                                <el-checkbox :label="item.id"></el-checkbox>
                            </div>
                        </div>
                        <div class="titleImg_right">
                            <div class="titleImg_top">
                                <h4>
                                    <span>订单编号:{{item.outTradeNo}}</span>
                                    <span class="normalSty">￥{{item.money}}</span>
                                </h4>
                                <p>
                                    <span v-if="item.videoInfo">购买视频：{{ item.videoInfo.videoName }}</span>
                                    <span v-else> <span v-if="item.memberType"> {{item.memberType.typeName }}充值</span> </span>
                                </p>
                            </div>
                            <p>
                                <span>{{item.createdTime|formatDate}}</span>
                            </p>
                        </div>
                    </div>
                </el-checkbox-group>
            </div>
            <!-- 最近一周 -->
            <div v-if="tabsCard.num == 1">
                <el-checkbox-group v-model="checkList">
                    <div class="orderItem" v-for="(item,index) in showData" :key='index'>
                        <div class="titleImg">
                            <div class="order-img" @click="jumpToVideo(item.videoInfo.status, item.videoInfo.id)">
                                <img v-if="item.videoInfo" :src="item.videoInfo.horizontalImage" alt="">
                                <img v-else src="@/assets/images/mine/vip_recharge.png" alt="">
                            </div>
                            <div class="layer" v-show="isEdit">
                                <el-checkbox :label="item.id"></el-checkbox>
                            </div>
                        </div>
                        <div class="titleImg_right">
                            <div class="titleImg_top">
                                <h4>
                                    <span>订单编号:{{item.outTradeNo}}</span>
                                    <span class="normalSty">￥{{item.money}}</span>
                                </h4>
                                <p>
                                    <span v-if="item.videoInfo">购买视频：{{ item.videoInfo.videoName }}</span>
                                    <span v-else> <span v-if="item.memberType"> {{item.memberType.typeName }}充值</span> </span>
                                </p>
                            </div>
                            <p>
                                <span>{{item.createdTime|formatDate}}</span>
                            </p>
                        </div>
                    </div>
                </el-checkbox-group>
            </div>
            <!-- 最近一月 -->
            <div v-if="tabsCard.num == 2">
                <el-checkbox-group v-model="checkList">
                    <div class="orderItem" v-for="(item,index) in showData" :key='index'>
                        <div class="titleImg">
                            <div class="order-img" @click="jumpToVideo(item.videoInfo.status, item.videoInfo.id)">
                                <img v-if="item.videoInfo" :src="item.videoInfo.horizontalImage" alt="">
                                <img v-else src="@/assets/images/mine/vip_recharge.png" alt="">
                            </div>
                            <div class="layer" v-show="isEdit">
                                <el-checkbox :label="item.id"></el-checkbox>
                            </div>
                        </div>
                        <div class="titleImg_right">
                            <div class="titleImg_top">
                                <h4>
                                    <span>订单编号:{{item.outTradeNo}}</span>
                                    <span class="normalSty">￥{{item.money}}</span>
                                </h4>
                                <p>
                                    <span v-if="item.videoInfo">购买视频：{{ item.videoInfo.videoName }}</span>
                                    <span v-else> <span v-if="item.memberType"> {{item.memberType.typeName }}充值</span> </span>
                                </p>
                            </div>
                            <p>
                                <span>{{item.createdTime|formatDate}}</span>
                            </p>
                        </div>
                     </div>
                </el-checkbox-group>
            </div>
            <!-- 全部 -->
            <div v-if="tabsCard.num == 3">
                <el-checkbox-group v-model="checkList">
                    <div class="orderItem" v-for="(item,index) in showData" :key='index'>
                        <div class="titleImg">
                            <div class="order-img" @click="jumpToVideo(item.videoInfo.status, item.videoInfo.id)">
                                <img v-if="item.videoInfo" :src="item.videoInfo.horizontalImage" alt="">
                                <img v-else src="@/assets/images/mine/vip_recharge.png" alt="">
                            </div>
                            <div class="layer" v-show="isEdit">
                                <el-checkbox :label="item.id"></el-checkbox>
                            </div>
                        </div>
                        <div class="titleImg_right">
                            <div class="titleImg_top">
                                <h4>
                                    <span>订单编号:{{item.outTradeNo}}</span>
                                    <span class="normalSty">￥{{item.money}}</span>
                                </h4>
                                <p>
                                    <span v-if="item.videoInfo">购买视频：{{ item.videoInfo.videoName }}</span>
                                    <span v-else> <span v-if="item.memberType"> {{item.memberType.typeName }}充值</span> </span>
                                </p>
                            </div>
                            <p>
                                <span>{{item.createdTime|formatDate}}</span>
                            </p>
                        </div>
                    </div>
                </el-checkbox-group>
            </div>
            <div v-show="isShowNoContent" class="no-data">
                <img src="@/assets/images/no_data.png" alt="暂无订单记录">
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import { getToken, setToken, setUser } from '../../../utils/auth.js';
    import {formatDate } from '../../../utils/date.js'
    export default {
        data() {
            return {
                todayBeginTime: null,
                todayEndTime: null,
                lastWeekTime: null,
                lastMonthTime: null,
                isEdit: false, // 是否编辑
                checkList: [], // 选择数组
                tabsCard: {
                    tabs: ['今天','最近一周','最近一月','全部'],
                    num: 0
                },
                videoName:'',
                showData: [], // 主体展示数据
                isShowNoContent: false,  // 是否展示无内容提示
            }
        },
        filters:{
            formatDate(time){
                let date = new Date(time);
                return formatDate(date,'yyyy-MM-dd hh:mm:ss');
            }
        },
        methods: {
            tab(index) {
                this.tabsCard.num = index
                let beginTime
                let endTime
                switch(index) {
                    case 0 :
                        beginTime = this.todayBeginTime
                        break
                    case 1:
                        beginTime = this.lastWeekTime
                        break
                    case 2:
                        beginTime = this.lastMonthTime
                        break
                }
                 let obj = {
                    params: index !== 3 ? {
                        beginTime: beginTime,
                        endTime: this.todayEndTime,
                        orderByType: 'DESC'
                     } : { orderByType: 'DESC' },
                    fn: (res) => {
                        this.showData = res; 
                    }
                }
                this.orderFn(obj); 
            },
            orderFn(obj){
                console.log(obj.params)
                let data = {
                    token: getToken()
                };
                axios({
                    method: 'get',
                    url: '/realNet/order/getOrders',
                    headers: data,
                    params: obj.params
                })
                .then((res) =>{
                    if(res.data.result.content.length == 0) {
                        this.isShowNoContent = true;
                    } else {
                        this.isShowNoContent = false;
                    }
                    obj.fn(res.data.result.content);
                })
                .catch(function (error) {
                    console.log(error);
                });
            },
            changeEditStatus() {
                this.isEdit = true;
            },
            cancelEdit(status) {
                if(status) {
                    // 选中删除的卡片
                    console.log(this.checkList)
                    if (this.checkList.length === 0) {
                        return this.$message.warning('请选择要删除的数据')
                    }
                    this.delCollect()
                } else {
                    this.isEdit = false
                    this.checkList = []
                }
            },
            delCollect(){
                this.$confirm('确定删除吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let params = {
                        token: getToken()
                    }
                    let data = {
                        "orderIds": this.checkList.join(',')   // 观看历史的类型
                    }
                    axios({
                        method: 'delete',
                        url: '/realNet/order/delete',
                        headers: params,
                        data:data
                    })
                    .then((res) =>{
                        //删除成功
                        this.$message({
                            showClose: true,
                            message: '删除成功',
                            type: 'success',
                            duration: 1000
                        })
                        
                        this.isEdit = false
                        this.checkList = []
                        //刷新页面
                        this.tab(this.tabsCard.num)
                    })
                    .catch(function (error) {
                        console.log(error)
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    })      
                })
            },
            jumpToVideo(status, id) {
                if (status === 1) {
                    this.$router.push({ path: 'tvplay-page', query: { contentId: id} })
                } else if (status === 2) {
                    this.$message.warning('此视频已下架，请观看其他视频')
                }
            }
        },
        mounted() {
            let now = new Date()

            // 今天开始与结束时间
            let todayBegin = formatDate(now, 'yyyy-MM-dd') +' 00:00:00'
            let todayEnd = formatDate(now, 'yyyy-MM-dd') +' 23:59:59'

            // 上周开始时间
            let date = now.getDate()
            let month = now.getMonth()
            let year = now.getFullYear()
            let lastWeek = new Date(year, month, date - 6)
            let lastWeekBegin = formatDate(lastWeek, 'yyyy-MM-dd') +' 00:00:00'

            // 上月开始时间
            let lastMonth = new Date(year, month, date - 30)
            let lastMonthBegin = formatDate(lastMonth, 'yyyy-MM-dd') +' 00:00:00'

            // 转换为时间戳
            this.todayBeginTime = new Date(todayBegin).getTime()
            this.todayEndTime = new Date(todayEnd).getTime()
            this.lastWeekTime = new Date(lastWeekBegin).getTime()
            this.lastMonthTime = new Date(lastMonthBegin).getTime()
            let obj = {
                params: {
                    // 需求接口请求字段参数
                    beginTime: this.todayBeginTime,
                    endTime: this.todayEndTime,
                    orderByType: 'DESC'
                },
                fn: (res) => {
                   this.showData = res; 
                }
            }
           this.orderFn(obj)
        }
    }
</script>

<style lang='scss' scoped>
    .order {
        width: 930px;

        .order_head {
            width: 100%;
            height: 41px;
            border: 1px solid #EAECED;
            padding: 0 40px;
            margin-bottom: 30px;

            background-color: #F9F9F9;
            box-sizing: border-box;

            display: flex;
            justify-content: space-between;
            align-items: center;

            ul {
                width: 70%;
                height: 100%;
                padding: 0;

                li {
                    height: 100%;
                    padding: 0 20px;

                    display: flex;
                    align-items: center;
                    justify-content: center;
                    float: left;
                    font-size: 14px;
                    position: relative;
                    
                    span {
                        cursor: pointer;
                    }
                }
                .active {
                    font-weight: bold;

                    &::before {
                        position: absolute;
                        left: 50%;
                        margin-left: -15px;
                        bottom: -2px;
                        content: '';
                        background-color: #3BC0D0;
                        width: 35px;
                        height: 3px;
                    }
                }
            }
                    
            & > span {
                font-size: 14px;
                color: #2CB5C5;
                cursor: pointer;
            }

            .barSty {
                font-size: 14px;
                color: #2CB5C5;
                cursor: pointer;
            }

        }

        .main {
            width: 100%;

            .orderItem {
                width: 930px;
                height: 135px;
                margin-bottom: 30px;


                display: flex;

                .titleImg {
                    position: relative;
                    width: 240px;
                    height: 135px;
                    margin-right: 30px;
                    background-color: #ccc;
                    cursor: pointer;
                    .order-img > img {
                        width: 240px;
                        height: 135px; 
                    }
                    .layer {
                        position: absolute;
                        left: 0;
                        top: 0;
                        z-index: 10;
                        width: 100%;
                        height: 100%;
                        background-color: rgba(#000,.3);
                    }
                }
                .titleImg_right {
                    width: 615px;
                    height: 100%;
                    padding: 10px 0;

                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;

                    box-sizing: border-box;

                    .titleImg_top {
                        width: 100%;
                        height: 60px;

                        h4 {
                            width: 100%;
                            height: 25px;
                            margin-bottom: 16px;

                            display: flex;
                            justify-content: space-between;

                            font-size: 20px;
                            .normalSty {
                                color: #666666;
                                font-weight: normal;
                            }
                        }
                        p {
                            font-size: 16px;
                            color: #888888;
                        }
                    }

                    & > p {
                        font-size: 16px;
                        color: #888888;
                    }
                }
            }
            .no-data {
                text-align: center;
            }
         }

    }
</style>
